import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { PresetKey } from '../registry/presets';

interface Props {
    value: PresetKey;
    onChange: (p: PresetKey) => void;
    /** Presets to offer; defaults to all three. The board passes only the presets the user is granted. */
    options?: PresetKey[];
}

const LABELS: Record<PresetKey, string> = { owner: 'Business owner', manager: 'Manager', accountant: 'Accountant', basic: 'Basic' };
// `basic` is a solo fallback board — it never appears in the switcher alongside another board — so it is
// intentionally excluded from the toggle options.
const ALL: PresetKey[] = ['owner', 'manager', 'accountant'];

export default function RolePreviewToggle({ value, onChange, options }: Props) {
    const keys = (options ?? ALL).filter(k => ALL.includes(k));
    return (
        <ToggleButtonGroup
            size="small"
            exclusive
            value={value}
            onChange={(_, v) => { if (v) onChange(v as PresetKey); }}
            aria-label="View as role"
        >
            {keys.map(k => (
                <ToggleButton key={k} value={k}>{LABELS[k]}</ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}
